export const CustomFieldType = {
    String: 'String',
    Dropdown: 'Dropdown',
}

export const CustomFieldsPrefix = 'custom_'



// WEBPACK FOOTER //
// ./web/js/customFields/constants.js